<template>
	<div id="pageRoot">
	
		<!-- TEXTS ----------------------------------------------------------------------------------------------------->
		<p class="textBase" id="text01">
			Escribe otra palabra que rime y luego dibújala.
		</p>
		<p class="textBase" id="text02">
			Sube fotos de tus dibujos.
		</p>

		<p class="textBase" id="text03">
			VOLAR
		</p>

		<p class="textBase" id="text04">
			CANILLA
		</p>
		<p class="textBase" id="text05">
			CERRO
		</p>

		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01"/>
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 id="inputField02"/>
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=3 id="inputField03"/>

		<uploaded-image class="image01 pageElement" v-bind:page="$parent.page" v-bind:type="$parent.type" number=2></uploaded-image>
		<uploaded-image class="image02 pageElement" v-bind:page="$parent.page" v-bind:type="$parent.type" number=3></uploaded-image>
		<uploaded-image class="image03 pageElement" v-bind:page="$parent.page" v-bind:type="$parent.type" number=4></uploaded-image>			
		<!--BUTTONS--------------------------------------------------------------------------------------------------------->
		<div id="buttonUploadImage01" style="position: absolute; margin-left: 13.3%; margin-top: 55%;">
			<image-upload v-bind:page="$parent.page" v-bind:type="$parent.type" number=2></image-upload>
		</div>
		<div id="buttonUploadImage02" style="position: absolute; margin-left: 40%; margin-top: 55%;">
			<image-upload v-bind:page="$parent.page" v-bind:type="$parent.type" number=3></image-upload>
		</div>
		<div id="buttonUploadImage03" style="position: absolute; margin-left: 67.6%; margin-top: 55%;">
			<image-upload v-bind:page="$parent.page" v-bind:type="$parent.type" number=4></image-upload>
		</div>
		<!-- TEXTS ----------------------------------------------------------------------------------------------------->

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<div class="pageSVG">
			<img src="/pages/img/sordo/svgPage67Background.svg" class="pageElement" style=" width: 100%; height: auto;">
		</div>
		<span class="footer-page footer-write"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
.textBase 
{
margin:0px;
z-index: 3;
font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 33px;
color: #000000;
}

#text01 
{
/* Escribe otra palabra que rime y luego dibújala. */
position: absolute;
width: 635px;
height: 30px;
left: 120px;
top: 41px;
}

#text02 
{
/* Sube fotos de tus dibujos */
position: absolute;
width: 307px;
height: 35px;
left: 120px;
top: 78px;
}

#text03 
{
/* VOLAR */
position: absolute;
width: 137px;
height: 58px;
left: 165px;
top: 143px;

font-size: 33px;
line-height: 45px;
text-align: center;
color: #FFFCFC;
}


#text04 
{
/* CANILLA */
position: absolute;
width: 137px;
height: 58px;
left: 440px;
top: 143px;

font-size: 33px;
line-height: 45px;
text-align: center;
color: #FFFCFC;
}

#text05 
{
/* CERRO */
position: absolute;
width: 137px;
height: 58px;
left: 722px;
top: 143px;

font-size: 33px;
line-height: 45px;
text-align: center;
color: #FFFCFC;
}

#inputField01
{
font-size: 28px;
position: absolute;
width: 218px;
left: 115px;
top: 203px;
z-index: 3;
}
#inputField02
{
font-size: 28px;
position: absolute;
width: 218px;
left: 390px;
top: 203px;
z-index: 3;
}
#inputField03
{
font-size: 28px;
position: absolute;
width: 218px;
left: 671px;
top: 203px;
z-index: 3;
}
.image01{
position: absolute;
left: 120px;
top: 276px;
width: 230px;
height: 312px;
}
.image02{
position: absolute;
left: 38.6%;
top: 276px;
width: 230px;
height: 312px;
}
.image03{
position: absolute;
left: 66%;
top: 276px;
width: 230px;
height: 312px;
}
</style>

<script>
	import ImageUpload from '../../../components/ImageUpload.vue'
	export default 
	{
		name: 'App',
		components:
		{
			ImageUpload
		}
	}
</script>